import coreEdit from "./coreEdit.vue";
export default coreEdit;
